import React, { useState } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { WINE_DETAIL_ROWS } from "../lib/wines";

export default function WineDetailDialog({ wine, images, open, onOpenChange }) {
  const [active, setActive] = useState(0);
  const current = images[active] || images[0];
  const rows = WINE_DETAIL_ROWS.filter((r) => String(wine[r.key] ?? "").trim() !== "");

  return (
    <DialogPrimitive.Root open={open} onOpenChange={(o) => { onOpenChange(o); if (!o) setActive(0); }}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-charcoal/70" />
        <DialogPrimitive.Content
          data-testid={`wine-detail-${wine.slug}`}
          className="fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-3xl max-h-[90vh] overflow-y-auto -translate-x-1/2 -translate-y-1/2 bg-ivory border border-charcoal/10 focus:outline-none"
        >
          <div className="grid md:grid-cols-2">
            <div className="bg-cream">
              <div className="aspect-[4/5] flex items-center justify-center">
                {current ? (
                  <img src={current.src} alt={current.alt} className="w-full h-full object-cover" />
                ) : (
                  <span className="text-burgundy/25 font-serif text-6xl italic select-none" aria-hidden="true">{wine.name.charAt(0)}</span>
                )}
              </div>
              {images.length > 1 && (
                <div className="grid grid-cols-2 gap-2 p-2">
                  {images.map((im, i) => (
                    <button key={im.src} type="button" onClick={() => setActive(i)} aria-label={`Zobrazit fotografii ${i + 1}`} aria-pressed={i === active}
                      data-testid={`wine-detail-thumb-${i}`}
                      className={`aspect-[4/3] overflow-hidden border-2 ${i === active ? "border-burgundy" : "border-transparent"}`}>
                      <img src={im.src} alt="" className="w-full h-full object-cover" />
                    </button>
                  ))}
                </div>
              )}
            </div>
            <div className="p-6 md:p-8">
              <DialogPrimitive.Title className="font-serif text-3xl text-charcoal pr-8">{wine.name}</DialogPrimitive.Title>
              <DialogPrimitive.Description className="sr-only">Podrobné informace o víně {wine.name}</DialogPrimitive.Description>
              <dl className="mt-6 divide-y divide-charcoal/10 border-y border-charcoal/10 text-sm">
                {rows.map((r) => (
                  <div key={r.key} className="flex justify-between gap-4 py-2.5" data-testid={`wine-detail-row-${r.key}`}>
                    <dt className="text-charcoal/60">{r.label}</dt>
                    <dd className="text-charcoal text-right">{wine[r.key]}</dd>
                  </div>
                ))}
                <div className="flex justify-between gap-4 py-2.5">
                  <dt className="text-charcoal/60">Cena</dt>
                  <dd className="text-burgundy font-serif text-lg">{wine.price} Kč / láhev</dd>
                </div>
              </dl>
              <p className="mt-5 text-xs text-charcoal/60 leading-relaxed">Dostupnost, způsob převzetí a konečnou cenu potvrdíme osobně. Nákup vína je určen osobám starším 18 let.</p>
            </div>
          </div>
          <DialogPrimitive.Close data-testid="wine-detail-close" aria-label="Zavřít" className="absolute right-3 top-3 p-2 bg-ivory/90 hover:bg-cream text-charcoal">
            <X size={18} />
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
